import { render, staticRenderFns } from "./ChannelStatistics.vue?vue&type=template&id=85128646&scoped=true"
import script from "./ChannelStatistics.vue?vue&type=script&lang=js"
export * from "./ChannelStatistics.vue?vue&type=script&lang=js"
import style0 from "./ChannelStatistics.vue?vue&type=style&index=0&id=85128646&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85128646",
  null
  
)

export default component.exports